import { TableItemNumber } from './table-item-number';
import { formatTime } from '../../util';

export function TableItemTime ({ value, numberFormat, inputFormat, bold }) {
	return (<TableItemNumber title value={value} numberFormat={numberFormat} bold={bold}>
		{formatTime(numberFormat, value, inputFormat)}<span class="time-unit" />
	</TableItemNumber>);
}



// WEBPACK FOOTER //
// ./components/table/table-item-time.js